import React from "react";

export default class ListenerComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isSomethingPending: false,
    };
    this.handleGlobalStateChange = this.handleGlobalStateChange.bind(this);
  }

  handleGlobalStateChange(e) {
    const actions = ['showAppLoader', 'hideAppLoader'];

    if (!e.arguments || !e.arguments[0]) {
      return
    }

    const obj = e.arguments[0]
    const action = Object.keys(obj)[0]
    if (!actions.includes(action)) {
      return
    }
    const value = obj[action]
    switch (action) {
      case 'showAppLoader':
        if (typeof value === 'object' && !!value.size) {
          this.setState({ isSomethingPending: true });
        }
        break;
      case 'hideAppLoader':
        if (typeof value === 'object' && value.size === 0) {
          this.setState({ isSomethingPending: false });
        }
        break;
      default:
    }
  }

  render() {
    return <></>
  }
}